/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth


 (function ($, Drupal, drupalSettings) { // UNCOMMENT IF DRUPAL.
//
   //Drupal.behaviors.mainMenu = {
     //attach: function (context) {

  'use strict';

  // Use context instead of document IF DRUPAL.
  var toggle_expand = document.getElementById('toggle-expand');
  var menu = document.getElementById('main-nav');
  var expand_menu = menu.getElementsByClassName('expand-sub');

  // Mobile Menu Show/Hide.
  toggle_expand.addEventListener('click', function (e) {
    toggle_expand.classList.toggle('toggle-expand--open');
    menu.classList.toggle('main-nav--open');
  });

  //Expose mobile sub menu on click.
  for (var i = 0; i < expand_menu.length; i++) {
    expand_menu[i].addEventListener('click', function (e) {
      var menu_item = e.currentTarget;
      var mnu_itm = menu_item.previousElementSibling;
      var sub_menu = menu_item.nextElementSibling;

      mnu_itm.classList.toggle('exp');
      menu_item.classList.toggle('expand-sub--open');
      sub_menu.classList.toggle('main-menu--sub-open');
    });
  }

  
  $(document).ready(function() {
    $('.main-menu > .abt-lnk > .main-menu__link, .main-menu > .gd-3 > .main-menu__link, .main-menu > .rsrc-lnk.main-menu__item  > .main-menu__link').click(function(e){
      e.preventDefault();
    });

    $('.sec_nav ul .menu-item:first span').addClass('selected');
      $('.sec_nav ul .menu-item span').click(function(){
        event.preventDefault();
        //$(this).addClass( 'selected' );
        $('.sec_nav ul .menu-item span.selected').removeClass( 'selected' );
        $(this).addClass( 'selected' );
     
      });
      $('.sec_nav ul .menu-item:first-child').click(function(){
        $('.simple-layout').find('.fnd_mem').addClass('frm_active');
        $('.simple-layout').find('.fnd_mem').next().removeClass('frm_active');
      });
      $('.sec_nav ul .menu-item:last-child').click(function(){
        $('.simple-layout').find('.fnd_mem').addClass('frm_active');
        $('.simple-layout').find('.fnd_mem').prev().removeClass('frm_active');
      });  

  
 });

  /* jump links */
  $(".block-region-row4").attr('id','tab1');
  $(".block-region-row5").attr('id','tab2');
  $(".faq-blk").attr('id','tab3');
  $(".block-region-row8").attr('id','tab4');
      var lastId,
      topMenu = $(".sec_nav .menu"),
      topMenuHeight = topMenu.outerHeight()+55,
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
      });

  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
    $('html, body').stop().animate({ 
        scrollTop: offsetTop
    }, 300);
    e.preventDefault();
  });

  // Bind to scroll
  $(window).scroll(function(){
    // Get container scroll position
    var fromTop = $(this).scrollTop()+topMenuHeight;
    
    // Get id of current scroll item
    var cur = scrollItems.map(function(){
      if ($(this).offset().top < fromTop)
        return this;
    });
    // Get the id of the current element
    cur = cur[cur.length-1];
    var id = cur && cur.length ? cur[0].id : "";
    
    if (lastId !== id) {
        lastId = id;
        // Set/remove active class
        menuItems
          .parent().removeClass("active")
          .end().filter("[href='#"+id+"']").parent().addClass("active");
    }                   
  });
    $(document).on('click', '.faq-blk .field--name-dynamic-token-fieldnode-faq-title', function () {
    var get_url = $(this).find('.field--item h2').attr('class');
    window.history.pushState({}, $(this).text(), get_url);

      // $('.field--name-dynamic-token-fieldnode-faq-title .field--item').removeClass('active');
      // $('.text-long').removeClass('active');

    if ($(this).next('.text-long').hasClass('active')) {
    $(this).removeClass('active');
    $(this).children('.field--item').removeClass('active');
    $(this).next('.text-long').removeClass('active');
    $(this).closest('.views-row').css({
    "background": "transparent"
    });
    } else {
    $(this).children('.field--item').addClass('active');
    $(this).next('.text-long').addClass('active');
    // $(this).closest('.views-row').css({
    // "background": "#f2f8ff"
    // });
    }
    });
  
  var pathname = decodeURIComponent(window.location.pathname);
  var split = "";
  split = pathname.split("/");
  //console.log(split);

    $(".faq-blk .field--name-dynamic-token-fieldnode-faq-title").each(function() {
      $(this).find('.field--item h2').attr('id',$(this).find('.field--item h2').attr('id').replace("/faqs/", ""));
    });

  if (split.length == 3) {
    $("#" + split[2]).parent(".field--item").addClass("active");
    $("#" + split[2]).parent().parent().next().addClass("active");
    if($("#" + split[2]).parent(".field--item").length) {
      $('html,body').animate({
        scrollTop: $("#" + split[2]).parent(".field--item").offset().top - 220
      }, 1000);
    }
  } else {
    $(".faq-blk .text-long").first().addClass("active");
    $('.faq-blk .field--name-dynamic-token-fieldnode-faq-title').first().children('.field--item').addClass('active');
  }

})(jQuery, Drupal, drupalSettings); // UNCOMMENT IF DRUPAL.
